module.exports = __webpack_public_path__ + "img/zj-1.14192db3.png";